module.exports = __webpack_public_path__ + "img/header-engagementRingsCharisma\n.5eecd46.webp";